import { MenuItemType } from './index';

const ATIVE: MenuItemType[] = [
  { key: 'vilacon', label: 'Vila Contábil', isTitle: true },
  {
    key: 'home',
    label: 'Home',
    isTitle: false,
    icon: 'fa-solid fa-house',
    //badge: { variant:'success', text:'4' },
    url: `/`,
  },
  {
    key: 'documents',
    label: 'Documentos',
    icon: 'fa-regular fa-file-lines',
    url: `/documents/clients`, //* 2 = DocumentOwnershipType.Client
  },
  {
    key: 'cadastros',
    label: 'Cadastros',
    icon: 'fa-solid fa-database',
    children: [
      {
        key: 'cliente',
        label: 'Clientes',
        icon: 'fa-solid fa-user',
        url: '/client',
        parentKey: 'cadastros',
      },
      /* Bugs a veriguar
            {
                key:'employees',
                label:'Usuários',
                //icon:'fa-solid fa-users',
                url: `/users`,
            },
            */
      {
        key: 'departments',
        label: 'Departamentos',
        icon: 'fa-solid fa-building',
        url: '/departments',
        parentKey: 'cadastros',
      },
      {
        key: 'activities',
        label: 'Atividades',
        icon: 'fa-solid fa-list-check',
        url: '/activities',
        parentKey: 'cadastros',
      },
      //{
      //    key:'obrigacoes',
      //    label:'Obrigações',
      //    url:'/obrigacoes',
      //    parentKey:'Obrigações',
      //},
    ],
  },
  {
    key: 'paymentPlan',
    label: 'Parcelamentos',
    icon: 'fa-solid fa-file-invoice',
    children: [
      {
        key: 'parcelamentos',
        label: 'Controle',
        icon: 'fa-solid fa-table-list',
        url: '/parcelamentos',
        parentKey: 'paymentPlan',
      },
      {
        key: 'modalidades',
        label: 'Modalidades',
        icon: 'fa-solid fa-puzzle-piece',
        url: '/modalidades',
        parentKey: 'paymentPlan',
      },
      {
        key: 'orgaos',
        label: 'Órgãos',
        icon: 'fa-solid fa-building-columns',
        url: '/orgaos',
        parentKey: 'paymentPlan',
      },
    ],
  },
  {
    key: 'contracts',
    label: 'Contratos',
    icon: 'fa-solid fa-briefcase',
    children: [
      {
        key: 'societarios',
        label: 'Societário',
        icon: 'fa-solid fa-briefcase',
        url: `/contracts/societario`,
      },
      {
        key: 'distratos',
        label: 'Distrato',
        icon: 'fa-solid fa-ban',
        url: `/contracts/distrato`,
      },
      {
        key: 'contractsAssistant',
        label: 'Talia',
        icon: 'fa-solid fa-wand-magic-sparkles',
        url: `/contracts/assistant`,
      },
    ],
  },
  {
    key: 'IRPF',
    label: 'IRPF',
    icon: 'fa-solid fa-receipt',
    children: [
      {
        key: 'taxclaimant',
        label: 'Declarantes',
        icon: 'fa-regular fa-user',
        url: `/taxclaimant`,
        parentKey: 'IRPF',
      },
      {
        key: 'documentsIRPF',
        label: 'Documentos',
        icon: 'fa-regular fa-file-lines',
        url: `/documents/tax-claimants`, //* 1 = DocumentOwnershipType.TaxClaimant
        parentKey: 'IRPF',
      },
      /*
      {
        key:'irpf_atendimento',
        label:'Atendimento',
        //url:'/irpf/atendimento',
      },
      {
        key:'irpf_declarantes',
        label:'Declarantes',
        //url:'/irpf/declarantes',
      },
      {
        key:'irpf_to_pay',
        label:'A Pagar',
        //url:'/irpf/pagar',
      },
      {
        key:'irpf_to_replay',
        label:'A restituir',
        //url:'/irpf/restituir',
      },
      {
        key:'irpf_message',
        label:'Mensagens',
        //url:'/irpf/mensagens',
      },
      {
        key:'irpf_recibos',
        label:'Recibos',
        //url:'/irpf/recibos',
      },
      */
    ],
  },
];

export default ATIVE;
